import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Form,
  Grid,
  Header,
  List,
  Message,
  Segment,
  Input,
} from "semantic-ui-react";
import { utils } from "../../../helpers/utils";

export function Dashboard() {
  const [isEmploymentCoordinator, setIsEmploymentCoordinator] =
    useState<boolean>(utils.isEmploymentCoordinator() || utils.isCoordinatorSupervisor());
  return (
    <Container className="dashboard-container">
      <Header as="h1" style={{ marginTop: "2.0rem", marginBottom: "0.5rem" }}>
        Dashboard
      </Header>
      <hr style={{ marginBottom: "2.0rem" }} />
      {isEmploymentCoordinator && <>
        <Grid columns={2} divided>
            <Grid.Row>
              <Grid.Column>
                <List divided relaxed="very" size="big">
                  <List.Item>
                    <List.Icon
                      name="comments outline"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"/RSASpecialistMeetingRequestList"}>
                          Employment Coordinator Meeting Request
                        </Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  
                </List>
              </Grid.Column>
              <Grid.Column>
                <List divided relaxed="very" size="big">
                  
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
      </>}
      {!isEmploymentCoordinator && (
        <>
          <Grid columns={2} divided>
            <Grid.Row>
              <Grid.Column>
                <List divided relaxed="very" size="big">
                  <List.Item>
                    <List.Icon
                      name="address card outline"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"/employerSpotlightPresentationList"}>
                          Employer Spotlight Presentation
                        </Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon
                      name="comments outline"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"/RSASpecialistMeetingRequestList"}>
                          Employment Coordinator Meeting Request
                        </Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon
                      name="graduation cap"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"/workshopList"}>Job Seeker Workshops</Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon
                      name="book"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"/CASASTestingList"}>
                          Manage CASAS Testing
                        </Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column>
                <List divided relaxed="very" size="big">
                  <List.Item>
                    <List.Icon
                      name="address book outline"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header>
                        <Link to={"providers"}>Providers</Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon
                      name="users"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"UsersList"}>
                          Manage DSS VRR Website Users
                        </Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon
                      name="tasks"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"manageHomepageSections"}>
                          Manage Home Page Sections
                        </Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon
                      name="handshake"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content>
                      <List.Header as="a">
                        <Link to={"manageEmploymentOpportunities"}>
                          Employment Opportunities
                        </Link>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </>
      )}
    </Container>
  );
}
